import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminHeaderComponent } from './admin-header/admin-header.component';

@Component({
  template: `
    <man-admin-header></man-admin-header>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'main' },
  standalone: true,
  imports: [RouterModule, AdminHeaderComponent]
})
export class AdminComponent {}
